<template>
    <canvas class="bubbles"></canvas>
</template>

<style lang="scss" scoped>
 .bubbles {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
  }
</style>
<script>
const enabled = true


export default {
  name: 'bubbles',
  data: function () {
    return { 
      // colors: ['255,255,100', '100,255,255', '255,100,255', '255,100,100', '100,255,100', '100,100,255'],
      colors: ['255,0,0','0,255,0','0,0,255'],
      parts: [],
      opacity: 0.15,
      minSpeed: 15,
      maxSpeed: 30,
      numParticles: 20,
      radius: 5,
      particles: [],
      canvas: null,
      canvas2: null,
      ctx: null,
      ctx2: null,
      mouseX: 0,
      mouseY: 0,
      repelDist: 0,
      repelBuffer: 10
	  }
  },
  methods: {
    createParticleTemplates: function () {
      for (var n=0; n < this.colors.length; n++) {
        let tmpCanvas = document.createElement('canvas')
        tmpCanvas.width = this.radius*2
        tmpCanvas.height = this.radius*2
        let tmpctx = tmpCanvas.getContext('2d')
        let grd = tmpctx.createRadialGradient(this.radius+(Math.random() /10),this.radius,this.radius,this.radius,this.radius,this.radius/1.25)
        grd.addColorStop(0, 'rgba(' + this.colors[n] + ', 0)')
        grd.addColorStop(1, 'rgba(' + this.colors[n] + ', ' + this.opacity + ')')
        tmpctx.fillStyle = grd;
        tmpctx.fillRect(0,0,this.radius*2,this.radius*2);
        this.parts[n] = tmpCanvas
      }
    },
    drawParticles: function () {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.ctx.fillStyle = "white"
      this.ctx.fillRect(0,0,this.canvas.width, this.canvas.height)
      for (var n=0; n < this.numParticles; n++) {
        this.moveParticle(this.particles[n])
        this.ctx.drawImage(this.particles[n].drawn, this.particles[n].xPos, this.particles[n].yPos)
        // this.ctx2.drawImage(this.particles[n].drawn, this.particles[n].xPos, this.particles[n].yPos)
      }
      this.ctx2.clearRect(0,0,this.canvas2.width, this.canvas2.height)
      this.ctx2.fillStyle = "white"
      this.ctx2.fillRect(0,0,this.canvas2.width, this.canvas2.height)
      this.ctx2.drawImage(this.canvas, 0,0)
      
    },
    resetParticle: function (particle) {
      let size = this.radius
      this.changeParticleColor(particle)
      let neg = 1
      let neg2 = 2;
      if (this.rand(0,1) > .5) neg = -1
      if (this.rand(0,1) > .5) neg2 = -2
      particle.xVel = this.rand(this.minSpeed, this.maxSpeed) * neg    
      particle.yVel = this.rand(this.minSpeed, this.maxSpeed) * neg2
      if (particle.xVel > 0) { //moving left to right
        if (particle.yVel > 0) { //moving top to bottom
          if (particle.xVel > particle.yVel) { //moving more horizontal
            particle.xPos = 0 - 2*size
            particle.yPos = this.rand(0,this.canvas.height)-size
          } else { //moving more vertical
            particle.yPos = 0 - 2*size
            particle.xPos = this.rand(0,this.canvas.width)-size
          }
        } else { //moving bottom to top
          if (particle.xVel > -particle.yVel) {  //moving more horizontal
            particle.xPos = 0 - 2*size
            particle.yPos = this.rand(0,this.canvas.height)-size
          } else { //moving more vertical
            particle.yPos = this.canvas.height
            particle.xPos = this.rand(0,this.canvas.width)-size
          }
        }
      } else { //moving right to left
        if (particle.yVel > 0) { //moving top to bottom
          if (-particle.xVel > particle.yVel) { //moving more horizontal
            particle.xPos = this.canvas.width
            particle.yPos = this.rand(0,this.canvas.height)-size
          } else { //moving more vertical
            particle.xPos = this.rand(0,this.canvas.width)-size
            particle.yPos = 0 - 2*size
          }
        } else { //moving bottom to top
          if (-particle.xVel > -particle.yVel) {  //moving more horizontal
            particle.xPos = this.canvas.width
            particle.yPos = this.rand(0,this.canvas.height)-size
          } else { //moving more vertical
            particle.yPos = this.canvas.height
            particle.xPos = this.rand(0,this.canvas.width)-size
          }
        }
      }
    },
    distanceBetween: function(x1,y1,x2,y2) {
      return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    },
    moveParticle: function (particle) {
      let dist = this.distanceBetween(particle.xPos+particle.radius, particle.yPos + particle.radius, this.mouseX, this.mouseY)
      
      if (dist <= this.repelDist + this.repelBuffer) {
        // console.log(dist)
        let x = particle.xPos + particle.radius
        let y = particle.yPos + particle.radius
        let dx = x - this.mouseX
        let dy = y - this.mouseY
        let moveDist = this.distanceBetween(0,0,particle.xVel,particle.yVel)
        let newx = Math.sqrt(moveDist / (dy / dx * (dy / dx) + 1))
        let newy = Math.sqrt(moveDist / (dx / dy * (dx / dy) + 1))
        if (dx < 0) newx = 0 - newx
        if (dy < 0) newy = 0 - newy
        let multiVel = (dist - this.repelDist) / (2 * this.repelBuffer) + 0.5
        let multiPush = 1 - multiVel;
        if (multiVel > 1) {
          multiVel = 1
          multiPush = 0
        } else if (multiVel < 0) {
          multiVel = 0
          multiPush = (dist - this.repelDist) / (-2 * this.repelBuffer) + 0.5
        }
        particle.xPos = particle.xPos + multiPush * newx + multiVel * particle.xVel;
        particle.yPos = particle.yPos + multiPush * newx + multiVel * particle.yVel;
      } else {
        particle.xPos += particle.xVel
        particle.yPos += particle.yVel
      }
      if (particle.xPos > this.canvas.width || particle.yPos > this.canvas.height || particle.xPos < -2 * particle.radius || particle.yPos < -2 * particle.radius) {
        this.resetParticle(particle)
      }
    },
    changeParticleColor: function (particle) {
      particle.drawn = this.parts[Math.floor(Math.random()*this.parts.length)]
    },
    rand: function (min,max) {
      return Math.random() * (max - min) + min;
    },
    moveMouse: function (e) {
      this.mouseX = e.x
      this.mouseY = e.y
      // console.log(this.mouseX, this.mouseY)
    },
    mouseDown: function(e) {
      this.repelDist = this.repelDist + 50
    },
    mouseUp: function(e) {
      this.repelDist = this.repelDist - 50
    },
    mouseLeave: function(e) {
      this.mouseX = this.canvas.width / 2
      this.mouseY = this.canvas.height / 3
    },    
    init: function () {
      if (!document.querySelector(".bmv-reflection .bubbles")) {
        setTimeout(this.init,30)
      } else {
        var w=window, d=document, e=d.documentElement, g=d.getElementsByTagName('body')[0], x=w.innerWidth||e.clientWidth||g.clientWidth, y=w.innerHeight||e.clientHeight||g.clientHeight;
        this.canvas = this.$el
        this.ctx = this.canvas.getContext('2d')
        this.canvas.width = x
        this.canvas.height = y
        this.ctx.fillStyle = "white"
        this.ctx.fillRect(0,0,x,y)
        this.canvas2 = document.querySelector('.bmv-reflection .bubbles')
        this.ctx2 = this.canvas2.getContext('2d')
        this.canvas2.width = x
        this.canvas2.height = y
        this.radius = this.repelDist = Math.max(y, x) / 1.5;
        this.createParticleTemplates()
        this.mouseX = x / 2;
        this.mouseY = y / 3;
        for (var n=0;n < this.numParticles; n++) {

          let neg = 1
          let neg2 = 2;
          if (this.rand(0,1) > .5) neg = -1
          if (this.rand(0,1) > .5) neg2 = -2
          this.particles[n] = {
            radius: this.radius,
            drawn: this.parts[Math.floor(Math.random()*this.parts.length)],
            xPos: this.rand(0,x) - this.radius,
            yPos: this.rand(0,y) - this.radius,
            xVel: this.rand(this.minSpeed, this.maxSpeed) * neg,
            yVel: this.rand(this.minSpeed, this.maxSpeed) * neg2
          }
        }
        
        this.canvas.addEventListener("mousemove", this.moveMouse, false)
        this.canvas.onmousedown = this.mouseDown
        this.canvas.onmouseup = this.mouseUp
        this.canvas.onmouseleave = this.mouseLeave
        requestInterval(this.drawParticles,1000/60)
      }
    }
  },
  mounted() {
    if (enabled) {
      this.init()
    }
  
  }
}
var requestInterval = function (fn, delay) {
  var requestAnimFrame = (function () {
    return window.requestAnimationFrame || function (callback, element) {
      window.setTimeout(callback, 1000 / 60);
    };
  })(),
  start = new Date().getTime(),
  handle = {};
  function loop() {
    handle.value = requestAnimFrame(loop);
    var current = new Date().getTime(),
    delta = current - start;
    if (delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }
  }
  handle.value = requestAnimFrame(loop);
  return handle;
};
</script>



// WEBPACK FOOTER //
// Bubbles.vue?7c7ee30a